import React from 'react';
import { DropletIcon, ClockIcon, HeartIcon, HomeIcon } from 'lucide-react';
const Benefits = () => {
  const benefits = [{
    icon: <DropletIcon size={48} className="text-[#2d98e2] mb-4" data-id="element-3" />,
    title: 'Agua Purificada',
    description: 'Acceso a agua purificada de la más alta calidad, garantizando la salud de tu familia.'
  }, {
    icon: <ClockIcon size={48} className="text-[#2d98e2] mb-4" data-id="element-4" />,
    title: 'Servicio Constante',
    description: 'Nunca más te quedarás sin agua. Nuestro sistema garantiza un suministro constante.'
  }, {
    icon: <HeartIcon size={48} className="text-[#2d98e2] mb-4" data-id="element-5" />,
    title: 'Impacto Social',
    description: 'Con cada suscripción, contribuyes a llevar agua a comunidades vulnerables.'
  }, {
    icon: <HomeIcon size={48} className="text-[#2d98e2] mb-4" data-id="element-6" />,
    title: 'Entrega a Domicilio',
    description: 'Recibe el agua directamente en tu hogar, sin esfuerzo y cuando lo necesites.'
  }];
  return <section id="como-funciona" className="py-16 bg-white" data-id="element-7">
      <div className="container mx-auto px-4" data-id="element-8">
        <div className="text-center mb-16" data-id="element-9">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4" data-id="element-10">
            Beneficios de Guaterflow
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto" data-id="element-11">
            Cada litro distribuido es una afirmación de que la constancia puede
            ser accesible, de que la dignidad puede ser diseñada, y el bienestar
            puede ser compartido.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-12">
          {benefits.map((benefit, index) => <div key={index} className="bg-blue-50 p-6 rounded-xl text-center hover:shadow-lg transition-shadow" data-id="element-13">
              <div className="flex justify-center" data-id="element-14">{benefit.icon}</div>
              <h3 className="text-xl font-semibold text-gray-800 mb-2" data-id="element-15">
                {benefit.title}
              </h3>
              <p className="text-gray-600" data-id="element-16">{benefit.description}</p>
            </div>)}
        </div>
      </div>
    </section>;
};
export default Benefits;